import { render, staticRenderFns } from "./LearningPlatform.vue?vue&type=template&id=66545031&scoped=true"
import script from "./LearningPlatform.vue?vue&type=script&lang=js"
export * from "./LearningPlatform.vue?vue&type=script&lang=js"
import style0 from "./LearningPlatform.vue?vue&type=style&index=0&id=66545031&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66545031",
  null
  
)

export default component.exports